/**
 * @Author: Lzp <liuzp@xinlongmail.com>
 * @Date: 2021-09-29 14:27:21
 * @LastEditors: Lzp
 * @LastEditTime: 2021-09-29 14:27:21
 */

import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/employment'
export default {
	updateEmp(id,data){
		return request.put(`${BASE_URL}/edit/${id}`,data)
	},
	/**
	 * getPaihuoEmploymentList
	 * @description 查看列表
	 * @author Lzp
	 * @date 2021/9/29
	 * @param {*} data
	 * @returns
	 */
	getPaihuoEmploymentResource(data) {
		return request.get(`${BASE_URL}/resource`, data)
	},
	getPaihuoEmploymentList(data) {
		return request.get(`${BASE_URL}/list`, data)
	},

	/**
	 * viewPaihuoEmployment
	 * @description 详情
	 * @author Lzp
	 * @date 2021/9/29
	 * @returns promise
	 */
	viewPaihuoEmployment(data) {
		return request.get(`${BASE_URL}/view/${data}`)
	},

	/**
	 * examinePaihuoEmployment
	 * @description 审核
	 * @author Lzp
	 * @date 2021/9/29
	 * @param {*} data
	 * @returns
	 */
	examinePaihuoEmployment(id, data) {
		return request.put(`${BASE_URL}/update/${id}`, data)
	},

	/**
	 * createEsignCompanyAccount
	 * @description 创建公司E签宝账号
	 * @author Lzp
	 * @date 2022/1/26
	 * @param {*} data
	 * @returns
	 */
	createEsignCompanyAccount(data) {
		return request.post(`/v1/manage/esign/create`, data)
	},
	/* 用工 */
	sysCompany_visual(id,data){
		return request.put(`/v1/manage/employment/virtual/account/${id}`, data)
	},
	/* 人资 */
	sysHRCompany_visual(id,data){
		return request.put(`/v1/manage/human/virtual/account/${id}`, data)
	},
    // 获取公司授权信息
    getAuthInfo(data){
        return request.get(`/v1/manage/esign/auth/info`, data)
    },
    
    // 发送企业授权
    postManagerEsignAuth(data){
        return request.post(`/v1/manage/esign/first_authorization`,data)
    },
    
    // 创建公章
    createSeal(data){
        return request.post(`/v1/manage/esign/create_seal`,data)
    },
    
    // 创建公章
    getSealList(data){
        return request.get(`/v1/manage/esign/seal_list`,data)
    },
    // 发起公章授权
    sendSealAuth(data){
        return request.post(`/v1/manage/esign/second_authorization`,data)
    },
    // 获取小程序列表
    getEmploymentMiniappList(id,data){
        return request.get(`/v1/manage/employment/app/list/${id}`, data)
    },
    createEmploymentMiniappInfo(id,data) {
        return request.post(`/v1/manage/employment/app/create/${id}`, data)
    },
    editEmploymentMiniappInfo(id,data) {
        return request.post(`/v1/manage/employment/app/save/${id}`, data)
    },
    deleteEmploymentMiniappList(id,data) {
        return request.Delete(`/v1/manage/employment/app/delete/${id}`, data)
    },
}
